import { Module } from "vuex";
import { RootState } from "@/services/store/root-state";
import { IMatchingSearchState } from "@/modules/matching/services/store/matching-search/matching-search.types";
import { mutations } from "@/modules/matching/services/store/matching-search/matching-search.mutations";
import { getters } from "@/modules/matching/services/store/matching-search/matching-search.getters";
import { actions } from "@/modules/matching/services/store/matching-search/matching-search.actions";

export const state: IMatchingSearchState = {
  loading: false,
  error: null,
  results: [],
  hit_count: 0,
  facets: {
    founding_date: { facet: "founding_date", options: [] },
    sectors: { facet: "sectors", options: [] },
    countries: { facet: "countries", options: [] },
    regions: { facet: "regions", options: [] },
  },
  page: 1,
  per_page: 30,
  filters: {
    vil: [],
    countries: [],
    sectors: [],
    query: "",
    founding_date: [],
    action: "search",
  },
};

export const matchingSearchModule: Module<IMatchingSearchState, RootState> = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
